import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import ProtectedRoute from "./components/ProtectedRoute";

import Search from "./pages/Search";
import List from "./pages/List";
import AddStudent from "./pages/AddStudent";
import Details from "./pages/Details";
import Register from "./pages/Register";

function App() {
  return (
    <Router>
      <Routes>

        {/* PUBLIC ROUTES */}
        <Route path="/" element={<Home />} />
        <Route path="/register" element={<Register />} />

        {/* PROTECTED ROUTES */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        >
          <Route path="search" element={<Search />} />
          <Route path="list" element={<List />} />
          <Route path="add" element={<AddStudent />} />
          <Route path="details/:id" element={<Details />} />
        </Route>

      </Routes>
    </Router>
  );
}

export default App;